import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios'; // Using axios for consistency

const ArticleListPage = () => {
  const { categoryName } = useParams();
  const [selectedCategory, setSelectedCategory] = useState('');
  const [allCategories, setAllCategories] = useState([]);
  const [articles, setArticles] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  // --- (NEW) State for pagination ---
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  useEffect(() => {
    axios.get('/api/articles/categories')
      .then(res => setAllCategories(res.data))
      .catch(() => setAllCategories([]));
  }, []);

  useEffect(() => {
    const fetchArticles = async () => {
        setIsLoading(true);
        setError(null);
        try {
            // --- (UPDATED) API endpoint now includes page number ---
            const apiUrl = `/api/articles/summary_list_cat/${categoryName}?page=${currentPage}&limit=10`;
            const response = await axios.get(apiUrl);
            setArticles(response.data.items);
            setTotalPages(response.data.totalPages);
        } catch (err) {
            console.error("Error fetching articles:", err);
            setError(err.message || "Failed to load articles.");
        } finally {
            setIsLoading(false);
        }
    };
    fetchArticles();
  }, [categoryName, currentPage]); // Re-run effect when currentPage changes

  // --- (NEW) Function to handle changing pages ---
  const handlePageChange = (newPage) => {
      if (newPage > 0 && newPage <= totalPages) {
          setCurrentPage(newPage);
      }
  };

  return (
    <div>
      {isLoading && <p>Loading articles...</p>}
      {error && <p className="error-message">Error: {error}</p>}
      <div className="content-list">
        {!isLoading && !error && (
          articles.length > 0 ? (
            articles.map((item) => (
              <Link to={`/articles/${item.id}`} key={item.id} className="content-card">
                <img 
                  src={item.banner_image_url || 'https://placehold.co/300x180?text=No+Image'}
                  alt={item.title}
                  className="content-card-thumbnail"
                  onError={e => { e.target.onerror = null; e.target.src = 'https://placehold.co/300x180?text=No+Image'; }}
                />
                <div className="content-card-body">
                  <h3 className="content-card-title">{item.title}</h3>
                  <p className="content-card-description">{item.category}</p>
                </div>
              </Link>
            ))
          ) : (
            <p>No articles found in this category.</p>
          )
        )}
      </div>

      {/* --- (NEW) Pagination Controls --- */}
      {!isLoading && totalPages > 1 && (
        <div className="pagination-container">
            <button 
                onClick={() => handlePageChange(currentPage - 1)} 
                disabled={currentPage === 1}
                className="pagination-button"
            >
                Previous
            </button>
            <span className="pagination-current-page">{currentPage}</span>
            <button 
                onClick={() => handlePageChange(currentPage + 1)} 
                disabled={currentPage === totalPages}
                className="pagination-button"
            >
                Next
            </button>
        </div>
      )}
    </div>
  );
};

export default ArticleListPage;